module.exports = __webpack_public_path__ + "assets/word_early_warning_default.0633b191.svg";